export enum CardsId {
  aiAutomation = "aiAutomation", 
  cloudEngineering = "cloudEngineering", 
  web3Infra = "web3Infra", 
  training = "training"
}
